/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PayPalPayflowProvider_configuration = {
    readonly currency: string;
    readonly organisationContact: string;
    readonly " $refType": "PayPalPayflowProvider_configuration";
};
export type PayPalPayflowProvider_configuration$data = PayPalPayflowProvider_configuration;
export type PayPalPayflowProvider_configuration$key = {
    readonly " $data"?: PayPalPayflowProvider_configuration$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PayPalPayflowProvider_configuration">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PayPalPayflowProvider_configuration",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organisationContact",
            "storageKey": null
        }
    ],
    "type": "Configuration",
    "abstractKey": null
} as any;
(node as any).hash = '49d3b35ddc9dd62070493f9444353c5a';
export default node;
